module.exports = __webpack_public_path__ + "static/cover.0971fda1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover.png
// module id = 507
// module chunks = 114276838955818